<template>
  <div class="consultingServicePage serviceIndex">
    <v-topBar :yellowPageColumn='yellowPageColumn'
              :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-topBar>
    <v-header class="hidden-xs hidden-sm"
              :navigationColumnInfos='navigationColumnInfos'
              :webConfigInfo='webConfigInfo'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-header>
    <el-row>
      <el-col :span="24">
        <div class="bgImg" @click="see(visibleUrl)" style="cursor: pointer;"></div>
        <div class="partTwo">
          <v-publiceTit :titleObj='titleObj'></v-publiceTit>
          <div class="introduce">
            <p>一链网“诚意供”服务能为您带来什么?</p>
            <p>为给供应商企业带来更优质的体验，一链网特别推出“诚意供”服务，开通即享尊贵待遇，收获丰盛福利：</p>
          </div>
          <ul class="row clearfix">
            <li class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                v-for="(item, index) in o" :key="index">
              <div class="clearfix">
                <span class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                  <img :src="item.src" alt="">
                </span>
                <div class="supplierManageLiCon col-xs-9 col-sm-9 col-md-9 col-lg-9">
                  <h3>{{item.h}}</h3>
                  <p class="desc">{{item.desc}}</p>
                </div>
              </div>
            </li>
          </ul>
          <p class="more">.....更多福利等您解锁！</p>
        </div>
        <div class="partThree">
          <v-publiceTit :titleObj='titleObjrisk' class="titleObjrisk"></v-publiceTit>
          <div class="serviceContent" style="max-width: 1200px;">
            <!--<img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E4%B8%80%E9%93%BE%E7%BD%91%E9%87%87%E8%B4%AD%E5%92%A8%E8%AF%A2%E6%9C%8D%E5%8A%A1.jpg" width="100%">-->
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5"></el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7"><span>服务项目</span></el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7">
                <span class="free">
                <h3>注册供应商</h3>
                <span style="margin: 0px;display: block;">（免费）</span>
              </span>
              </el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5">
              <span>
                <h3>“诚意供”服务</h3>
                <span style="margin: 0px;display: block;">(300 RMB/份*3个月)</span>
              </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5" style="height: 126px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/servicePrice_icon01.png" alt="" style="margin-right: 16px;">在线投标</span>
              </el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7" style="height: 126px;">
                <el-row>
                  <el-col :span="24">
                  <span>
                    公开招标项目报名
                  </span>
                  </el-col>
                  <el-col :span="24">
                    <span>公开询报价报名</span>
                  </el-col>
                  <el-col :span="24">
                    <span>收藏招标公告</span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7" style="height: 126px;">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png" alt="">
                  </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png" alt="">
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png" alt="">
                    </span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5" style="height: 126px;">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <p><span></span></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span>
                    <p><span></span></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span>
                    <p><span></span></p>
                  </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5" style="height: 126px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/servicePrice_icon02.png" alt="" style="margin-right: 16px;">商机服务</span>
              </el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                  <span>
                    商机推送
                  </span>
                  </el-col>
                  <el-col :span="24">
                    <span>优先推送给采购方</span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png" alt="">
                  </span>
                  </el-col>
                  <el-col :span="24">
                    <span><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/fail_icon.png" alt=""></span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <p><span></span></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span>
                    <p><span></span></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span></span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5" style="height: 126px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/servicePrice_icon03.png" alt="" style="margin-right: 16px;">征信认证</span>
              </el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>征信级别徽章</span>
                  </el-col>
                  <el-col :span="24">
                    <span>第三方征信报告</span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/fail_icon.png" alt=""></span>
                  </el-col>
                  <el-col :span="24">
                    <span><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/fail_icon.png" alt=""></span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <p></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span>
                    <p></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span></span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5" style="height: 126px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/servicePrice_icon04.png" alt="" style="margin-right: 16px;">增值服务</span>
              </el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>资源大厅搜索排名靠前</span>
                  </el-col>
                  <el-col :span="24">
                    <span>资源大厅企业主页</span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/fail_icon.png" alt=""></span>
                  </el-col>
                  <el-col :span="24">
                    <span><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png" alt=""></span>
                  </el-col>
                  <el-col :span="24">
                    <span></span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5">
                <el-row>
                  <el-col :span="24">
                  <span>
                    <p></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span>
                    <p></p>
                  </span>
                  </el-col>
                  <el-col :span="24">
                  <span></span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="5" :lg="5" :xl="5"></el-col>
              <el-col :xs="4" :sm="7" :md="7" :lg="7" :xl="7"><span></span></el-col>
              <el-col :xs="8" :sm="6" :md="7" :lg="7" :xl="7"><span></span></el-col>
              <el-col :xs="8" :sm="7" :md="5" :lg="5" :xl="5">
              <span>
                <el-button @click="see(visibleUrl)">立即购买</el-button>
              </span>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      custom-class="dialogReminder">
      <div class="reminderCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/expression_icon.png" alt="">
        <p class="title">您好，此服务仅提供给供应商哦</p>
        <p><span class="number">1</span>如果您有供应商账号请退出此账号重新登录后再进行购买</p>
        <p><span class="number">2</span>如果您是采购商，我们有“安心采”服务，专门帮助采购商降低采购风险 &nbsp<a @click="$router.push('creditReport')" style="color: #3F88E0;text-decoration: none;cursor: pointer;">立即查看</a></p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>

<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import publiceTit from '@/components/publiceTit'
  import {customActivityDetail, customActivityDetailBuyNow} from '@/assets/js/sensors'
  export default {
    name: '',
    data () {
      return {
        yellowPageColumn: {},
        productAndSolutionColumn: {},
        hitSearchUrl: '',
        enterpriseResourceBaseUrl: '',
        navigationColumnInfos: [],
        webConfigInfo: {},
        footerColumnInfos: [],
        o: [
          {
            src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/authoritative.jpg',
            h: '第三方征信机构权威认证',
            desc: '权威征信机构为企业出示信用报告，提升企业信用背书，享受征信级别徽章'
          },
          {
            src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/buiness.jpg',
            h: '商机服务',
            desc: '精准匹配商机，锁定目标客户，不错漏任何商机'
          },
          {
            src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/homepage.jpg',
            h: '专业版企业主页',
            desc: '定制企业页面，区别于普通用户，彰显尊贵身份'
          },
          {
            src: 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/sort.jpg',
            h: '排序优先',
            desc: '同等搜索条件下，优于基础企业版用户排名，增加企业曝光机会'
          }
        ],
        tableData: [{
          title: '在线投标',
          name: '公开招标项目报名'
        }, {
          name: '公开询报价报名'
        }, {
          name: '收藏招标公告'
        }, {
          title: '商机服务',
          name: '商机推送'
        }, {
          name: '优先推送给采购方',
          flag: '0'
        }, {
          name: ' '
        }, {
          title: '征信认证',
          name: '征信级别徽章',
          flag: '0'
        }, {
          name: '第三方征信报告',
          flag: '0'
        }, {
          name: ''
        }, {
          title: '增值服务',
          name: 'VIP徽章',
          flag: '0'
        }, {
          name: '资源大厅搜索排名靠前',
          flag: '0'
        }, {
          name: '资源大厅企业主页'
        }, {
          title: '',
          name: ''
        }],
        titleObj: {name: '核心价值', eng: 'Core value'},
        titleObjrisk: {name: '服务与价格', eng: 'Service and Price'},
        purchaseUrl: '',
        visibleUrl:'',
        dialogVisible:false
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-footer': footer,
      'v-backToTop': backToTop,
      'v-publiceTit': publiceTit
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
      this.getUrl()

      setTimeout(() => {
        // 埋点
        try {
          customActivityDetail({
            page_title: "诚意供"
          })
        } catch (e) {console.log(e)}
      })
    },
    methods: {
      getUrl () {
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findPaltformMapInfo', {
        }).then((res) => {
          this.purchaseUrl = res.data.creditPurchaseUrl;
          this.visibleUrl = res.data.creditSupplierUrl;
        }).catch((err) => {
          console.log(err)
        })
      },
      linkUrl () {
        window.location.href = this.purchaseUrl;
      },
      see (e) {
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          this.$alert('<p>请在PC端点击立即购买\n</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true
          })
        }else{
          if(this.getToken('isLogin') == ''){
            this.$router.push({path:'/login',query:{redirectURL:'/supplierService'}});
          }else if(this.getToken('userTag') == '20'){
            // this.$alert('<p>您是供应商身份，不能购买该服务。</p>', '', {
            //   dangerouslyUseHTMLString: true,
            //   customClass:'mobileText',
            //   center: true,
            //   showClose:false
            // });
            this.dialogVisible = true;
            return false;
          }else{
            window.location.href = e;
          }
        }

        // 埋点
        try {
          customActivityDetailBuyNow({
            page_title: "诚意供",
            button_position: "立即购买-下"
          })
        } catch (err) {console.log(err)}
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .serviceContent{
    margin: auto;
    text-align :left;
    background: #FFFFFF;
    border: 1px solid #E8ECF2;
    padding :24px;
    >.el-row{
      /*height:126px;*/
      >.el-col{
        height:100%;
        border-top :1px solid #E8ECF2;
        border-left :1px solid #E8ECF2;
        position :relative;
        font-size: 14px;
        color: #303133;
        >span{
          width :100%;
          padding :0px 20px;
          position:absolute;
          top: 50%;
          transform: translateY(-50%);
          text-align :center;
        }
        >.el-row{
          >.el-col{
            position :relative;
            height:42px;
            &:nth-child(odd){
              background : #F5F6FA;
            }
            >span{
              padding :0px 24px;
              position:absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        &:first-child{
          font-size: 18px;
        }
        &:nth-child(3){
          >.el-row{
            >.el-col{
              >span{
                width:100%;
                text-align :center;
              }
            }
          }
        }
        &:last-child{
          background: rgba(242, 194, 120, 0.1);
          border-left: 1px solid #F2C278;
          border-right: 1px solid #F2C278;
          border-top: 1px solid rgba(232, 236, 242, 0.5);

          .el-col{
            >span{
              width:100%;
              height:100%;
              >p{
                min-height: 100%;
                padding-left:40px;
                margin:0px;
                background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png") no-repeat center center;
                position :relative;
                >span{
                  position:absolute;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
              >p.not{
                padding-left:0px;
                background :none;
                span.notMark{
                  width :24px;
                  display :inline-block;
                  margin-right:16px;
                  text-align :center;
                }
              }
            }

            &:nth-child(odd){
              background : rgba(245, 246, 250, 0.5);
            }
            &:nth-child(even){
              background : rgba(255, 255, 255, 0.5);
            }
          }

        }
      }
      &:first-child,&:last-child{
        height:80px;
      }
      &:first-child{
        .el-col{
          font-size: 16px;
          color: #606266;
          line-height: 32px;
          >span{
            width:100%;
            text-align:center;
            h3{
              font-size: 16px;
              line-height: 32px;
              margin:0px;
              color: #F2AA3C;
              background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon.png") no-repeat left center;
              padding-left :30px;
              display :inline-block;
            }
          }
          >span.free{
            color: #606266;
            h3{
              font-size: 16px;
              line-height: 32px;
              margin:0px;
              color: #606266;
              background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/basicServices_icon.png") no-repeat left center;
              padding-left :30px;
              display :inline-block;
            }
          }
          &:last-child{
            line-height: 32px;
            color: #303133;
            border-top: 1px solid #F2C278;
            background :rgba(242, 194, 120, 0.1) url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_bg.png") no-repeat right top;
          }
        }
      }
      &:last-child{
        border-bottom: 1px solid #E8ECF2;
        .el-col{
          >span{
            left :50%;
            transform: translate(-50%,-50%);
          }
          &:last-child{
            border-bottom: 1px solid #F2C278;
            .el-button{
              max-width: 100%;
              width:180px;
              height:48px;
              background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
              border-radius: 4px;
              font-size: 18px;
              color: #FFFFFF;
              line-height: 18px;
              border :none;
            }
          }
        }
      }
      &:nth-child(odd){
        >.el-col{
          >.el-row{
            >.el-col{
              &:nth-child(odd){
                background : #fff;
              }
              &:nth-child(even){
                background : #F5F6FA;
              }
            }
          }
          &:last-child{
            >.el-row{
              >.el-col{
                &:nth-child(odd){
                  background : rgba(255, 255, 255, 0.5);
                }
                &:nth-child(even){
                  background : rgba(245, 246, 250, 0.5);
                }
              }
            }
          }
        }
      }
    }
  }
  .bgImg {
    width: 100%;
    height: 360px;
    position: relative;
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/1CBC365D-E030-4659-B1CE-AAD7B62DBB70.jpg') no-repeat center top;
    background-size: cover;
  }
  .partTwo,.partThree{
    text-align: center;
    padding: 64px 0;
  }
  .partTwo {
    font-family: PingFangSC-Regular;
    .introduce {
      font-size: 16px;
      color: #303133;
      text-align: center;
      line-height: 36px;
      margin: 30px 0;
      padding: 0 15px;
    }
    h3 {
      font-family: PingFangSC-Medium;
      font-size: 24px;
    }
    .desc {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
    }
    .more {
      font-size: 16px;
      color: #909399;
      text-align: center;
    }
  }

  .partThree {
    background: url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/price.jpg") no-repeat center top;
    background-size: cover;
  }
  .row {
    max-width: 1200px;
    margin: auto;
    li {
      margin-bottom: 48px;
      >div{
        background: #FFFFFF;
        box-shadow: 0 0 16px 0 rgba(0,0,0,0.10);
        padding: 25px;
        img {
          max-width: 100%;
        }
        span {
          padding: 0;
          display: inline-block;
        }
        h3 {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        div {
          text-align: left;
        }
      }
    }
  }
  @media (max-width: 767px){
    .serviceContent{
      margin:0px 10px;
      padding :10px;
      >.el-row{
        >.el-col{
          height:144px!important;
          border-top :1px solid #E8ECF2;
          border-left :1px solid #E8ECF2;
          position :relative;
          font-size: 12px;
          color: #303133;
          >span{
            padding :0px 10px;
            position:absolute;
            top: 50%;
            transform: translateY(-50%);
          }
          >.el-row{
            >.el-col{
              position :relative;
              height:48px;
              &:nth-child(odd){
                background : #F5F6FA;
              }
              >span{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                padding :0px 10px;
                position:absolute;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
          &:first-child{
            font-size: 14px;
          }
          &:nth-child(3){
            >.el-row{
              >.el-col{
                >span{
                  img{
                    width:16px;
                  }
                }
              }
            }
          }
          &:last-child{
            background: rgba(242, 194, 120, 0.1);
            border-left: 1px solid #F2C278;
            border-right: 1px solid #F2C278;
            border-top: 1px solid rgba(232, 236, 242, 0.5);

            .el-col{
              >span{
                width:100%;
                height:100%;
                >p{
                  width:100%;
                  min-height: 100%;
                  padding-left:26px;
                  margin:0px;
                  background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png") no-repeat center center;
                  background-size: 16px;
                  position :relative;
                  >span{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    position:absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  }
                }
                >p.not{
                  padding-left:0px;
                  background :none;
                  span.notMark{
                    width :16px;
                    display :inline-block;
                    margin-right:10px;
                    text-align :center;
                  }
                }
              }

              &:nth-child(odd){
                background : rgba(245, 246, 250, 0.5);
              }
              &:nth-child(even){
                background : rgba(255, 255, 255, 0.5);
              }
            }

          }
        }
        &:first-child,&:last-child{
          >.el-col{
            height:80px!important;
          }
        }
        &:first-child{
          .el-col{
            font-size: 12px;
            color: #606266;
            line-height: 16px;
            >span{
              width:100%;
              text-align:center;
              line-height: 24px;
              h3{
                font-size: 14px;
                line-height: 24px;
                margin:0px;
                color: #F2AA3C;
                background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon.png") no-repeat left center;
                background-size: 16px;
                padding-left :20px;
                display :inline-block;
              }
              >span{
                font-size:13px;
              }
            }
            >span.free{
              color: #606266;
              h3{
                font-size: 14px;
                line-height: 24px;
                margin:0px;
                color: #606266;
                background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon.png") no-repeat left center;
                background-size: 16px;
                padding-left :20px;
                display :inline-block;
              }
            }
            &:last-child{
              line-height: 32px;
              color: #303133;
              border-top: 1px solid #F2C278;
              background :rgba(242, 194, 120, 0.1) url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_bg.png") no-repeat right top;
              background-size: 40px;
            }
          }
        }
        &:last-child{
          border-bottom: 1px solid #E8ECF2;
          .el-col{
            >span{
              left :50%;
              transform: translate(-50%,-50%);
            }
            &:last-child{
              border-bottom: 1px solid #F2C278;
              .el-button{
                width:120px;
                height:32px;
                background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
                border-radius: 4px;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 18px;
                border :none;
                padding :0px;
              }
            }
          }
        }
        &:nth-child(5),&:nth-child(7){
          >.el-col{
            >.el-row{
              >.el-col{
                &:nth-child(odd){
                  background : #fff;
                }
                &:nth-child(even){
                  background : #F5F6FA;
                }
              }
            }
            &:last-child{
              >.el-row{
                >.el-col{
                  &:nth-child(odd){
                    background : rgba(255, 255, 255, 0.5);
                  }
                  &:nth-child(even){
                    background : rgba(245, 246, 250, 0.5);
                  }
                }
              }
            }
          }
        }
      }
    }
    .bgImg {
      height: 180px;
    }
    .partTwo,.partThree{
      text-align: center;
      padding: 40px 0;
    }
    .serviceIndex .titleObjrisk{
      margin-bottom :30px;
    }
  }
  @media screen and (max-width: 414px){
    .bgImg {
      height: 120px;
    }
    .serviceContent >.el-row >.el-col >span{
      padding: 0px 6px;
    }
    .serviceContent >.el-row:first-child .el-col >span{
      line-height :20px;
    }
    .serviceContent >.el-row:first-child .el-col >span h3{
      font-size: 12px;
      line-height: 20px;
      background-size: 14px;
      padding-left: 18px;
    }
    .serviceContent >.el-row:first-child .el-col >span >span{
      font-size :12px;
    }
    .serviceContent >.el-row:first-child .el-col:last-child{
      background-size: 34px;
    }
    .serviceContent >.el-row:first-child .el-col >span.free h3{
      font-size: 12px;
      line-height: 20px;
      background-size: 14px;
      padding-left: 18px;
    }
  }
  @media screen and (max-width: 360px){
    h3 {
      margin-top: 0;
    }
  }
</style>
<style lang="stylus">
  .serviceIndex{
    .titleObjrisk {
      margin-bottom: 48px;
    }
  }
  .titleObjrisk .title{
    .titleBg , .titleCon{
      color: #fff;
    }
    .line{
      background: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/supplierService/serviceIndex.vue